import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { usePendingProposals } from '../../hooks/usePendingProposals';

export function PendingProposalsBadge() {
  const { user } = useAuth();
  const { pendingCount } = usePendingProposals(user?.id || null);

  if (pendingCount === 0) return null;

  return (
    <a
      href="/proposals"
      className="relative inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-700 rounded-full text-sm font-medium hover:bg-yellow-200 transition-colors cursor-pointer"
    >
      <i className="ri-inbox-line"></i>
      <span>{pendingCount} Pending Proposal{pendingCount !== 1 ? 's' : ''}</span>
      <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
        {pendingCount}
      </div>
    </a>
  );
}
